(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1532,5240,3347],{

/***/ 14036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k1": function() { return /* binding */ useHubspotForm; },
/* harmony export */   "l0": function() { return /* binding */ HubspotProvider; }
/* harmony export */ });
/* unused harmony exports HubSpotFormLocale, useHubspotContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Locales supported by HubSpot forms
 */
var HubSpotFormLocale;
(function (HubSpotFormLocale) {
    /**
     * English
     */
    HubSpotFormLocale["ENGLISH"] = "en";
    /**
     * Danish
     */
    HubSpotFormLocale["DANISH"] = "da";
    /**
     * German
     */
    HubSpotFormLocale["GERMAN"] = "de";
    /**
     * Spanish (Spain)
     */
    HubSpotFormLocale["SPANISH"] = "es";
    /**
     * Spanish (Mexico)
     */
    HubSpotFormLocale["SPANISH_MEXICO"] = "es-mx";
    /**
     * Finnish
     */
    HubSpotFormLocale["FINNISH"] = "fi";
    /**
     * French
     */
    HubSpotFormLocale["FRENCH"] = "fr";
    /**
     * Italian
     */
    HubSpotFormLocale["ITALIAN"] = "it";
    /**
     * Japanese
     */
    HubSpotFormLocale["JAPANESE"] = "ja";
    /**
     * Dutch
     */
    HubSpotFormLocale["DUTCH"] = "nl";
    /**
     * Polish
     */
    HubSpotFormLocale["POLISH"] = "pl";
    /**
     * Portuguese
     */
    HubSpotFormLocale["PORTUGUESE"] = "pt-br";
    /**
     * Swedish
     */
    HubSpotFormLocale["SWEDISH"] = "sv";
    /**
     * Chinese
     */
    HubSpotFormLocale["CHINESE"] = "zh-cn";
    /**
     * Chinese (Hong Kong)
     */
    HubSpotFormLocale["CHINESE_HONG_KONG"] = "zh-hk";
})(HubSpotFormLocale || (HubSpotFormLocale = {}));

// Hook
var cachedScripts = [];
function useScript(src, async, addToHead) {
    if (async === void 0) { async = true; }
    if (addToHead === void 0) { addToHead = false; }
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loaded = _a[0], setLoaded = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), error = _b[0], setError = _b[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        // If cachedScripts array already includes src that means another instance ...
        // ... of this hook already loaded this script, so no need to load again.
        if (cachedScripts.includes(src)) {
            setLoaded(true);
            setError(false);
        }
        else {
            cachedScripts.push(src);
            // Create script
            var script_1 = document.createElement('script');
            script_1.src = src;
            script_1.async = async;
            // Script event listener callbacks for load and error
            var onScriptLoad_1 = function () {
                setLoaded(true);
                setError(false);
            };
            var onScriptError_1 = function () {
                // Remove from cachedScripts we can try loading again
                var index = cachedScripts.indexOf(src);
                if (index >= 0) {
                    cachedScripts.splice(index, 1);
                }
                script_1.remove();
                setLoaded(true);
                setError(true);
            };
            script_1.addEventListener('load', onScriptLoad_1);
            script_1.addEventListener('error', onScriptError_1);
            // Add script to document head if required, otherwise to the body
            addToHead
                ? document.head.appendChild(script_1)
                : document.body.appendChild(script_1);
            // Remove event listeners on cleanup
            return function () {
                script_1.removeEventListener('load', onScriptLoad_1);
                script_1.removeEventListener('error', onScriptError_1);
            };
        }
    }, [src]); // Only re-run effect if script src changes
    return [loaded, error];
}

var HubspotContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    loaded: false,
    error: false
});
var useHubspotContext = function () { return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HubspotContext); };
var HubspotProvider = function (_a) {
    var async = _a.async, addToHead = _a.addToHead, children = _a.children;
    // Attach hubspot script to the document
    var _b = useScript('https://js.hsforms.net/forms/v2.js', async, addToHead), loaded = _b[0], error = _b[1];
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(HubspotContext.Provider, { value: { loaded: loaded, error: error } }, children));
};

var useHubspotForm = function (props) {
    var _a = useHubspotContext(), loaded = _a.loaded, error = _a.error;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), formCreated = _b[0], setFormCreated = _b[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (typeof window !== 'undefined' && window) {
            var windowWithHubspot = window;
            if (loaded && windowWithHubspot.hbspt && !formCreated) {
                windowWithHubspot.hbspt.forms.create(props);
                setFormCreated(true);
            }
        }
    }, [loaded, formCreated, setFormCreated]);
    return { loaded: loaded, formCreated: formCreated, error: error };
};




/***/ }),

/***/ 23887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ Image2; },
/* harmony export */   "Ei": function() { return /* binding */ Img; }
/* harmony export */ });
/* unused harmony exports shouldShowFallbackImage, useImage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44040);
// ../../../react-shim.js


// src/image.tsx


// ../../utilities/object-utils/src/index.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone)
      delete clone[key];
  }
  return clone;
}

// src/use-image.ts


function useImage(props) {
  const {
    loading,
    src,
    srcSet,
    onLoad,
    onError,
    crossOrigin,
    sizes,
    ignoreFallback
  } = props;
  const [status, setStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("pending");
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setStatus(src ? "loading" : "pending");
  }, [src]);
  const imageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const load = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (!src)
      return;
    flush();
    const img = new Image();
    img.src = src;
    if (crossOrigin)
      img.crossOrigin = crossOrigin;
    if (srcSet)
      img.srcset = srcSet;
    if (sizes)
      img.sizes = sizes;
    if (loading)
      img.loading = loading;
    img.onload = (event) => {
      flush();
      setStatus("loaded");
      onLoad == null ? void 0 : onLoad(event);
    };
    img.onerror = (error) => {
      flush();
      setStatus("failed");
      onError == null ? void 0 : onError(error);
    };
    imageRef.current = img;
  }, [src, crossOrigin, srcSet, sizes, onLoad, onError, loading]);
  const flush = () => {
    if (imageRef.current) {
      imageRef.current.onload = null;
      imageRef.current.onerror = null;
      imageRef.current = null;
    }
  };
  (0,_chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useSafeLayoutEffect */ .G)(() => {
    if (ignoreFallback)
      return void 0;
    if (status === "loading") {
      load();
    }
    return () => {
      flush();
    };
  }, [status, load, ignoreFallback]);
  return ignoreFallback ? "loaded" : status;
}
var shouldShowFallbackImage = (status, fallbackStrategy) => status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";

// src/native-image.tsx

var NativeImage = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function NativeImage2(props, ref) {
  const { htmlWidth, htmlHeight, alt, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width: htmlWidth,
    height: htmlHeight,
    ref,
    alt,
    ...rest
  });
});
NativeImage.displayName = "NativeImage";

// src/image.tsx
var Image2 = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Image3(props, ref) {
  const {
    fallbackSrc,
    fallback,
    src,
    srcSet,
    align,
    fit,
    loading,
    ignoreFallback,
    crossOrigin,
    fallbackStrategy = "beforeLoadOrError",
    referrerPolicy,
    ...rest
  } = props;
  const providedFallback = fallbackSrc !== void 0 || fallback !== void 0;
  const shouldIgnoreFallbackImage = loading != null || ignoreFallback || !providedFallback;
  const status = useImage({
    ...props,
    ignoreFallback: shouldIgnoreFallbackImage
  });
  const showFallbackImage = shouldShowFallbackImage(status, fallbackStrategy);
  const shared = {
    ref,
    objectFit: fit,
    objectPosition: align,
    ...shouldIgnoreFallbackImage ? rest : omit(rest, ["onError", "onLoad"])
  };
  if (showFallbackImage) {
    if (fallback)
      return fallback;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
      as: NativeImage,
      className: "chakra-image__placeholder",
      src: fallbackSrc,
      ...shared
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
    as: NativeImage,
    src,
    srcSet,
    crossOrigin,
    loading,
    referrerPolicy,
    className: "chakra-image",
    ...shared
  });
});
Image2.displayName = "Image";

// src/img.tsx

var Img = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
  ref,
  as: NativeImage,
  className: "chakra-image",
  ...props
}));



/***/ }),

/***/ 77913:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _router = __webpack_require__(12199);

var _router1 = __webpack_require__(61587);

var _useIntersection = __webpack_require__(27215);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  router.prefetch(href, as, options).catch(err => {
    if (false) {}
  });
  const curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  const {
    target
  } = event.currentTarget;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
  const {
    nodeName
  } = e.currentTarget; // anchors inside an svg have a lowercase nodeName

  const isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault(); // replace state instead of push if prop is present

  router[replace ? 'replace' : 'push'](href, as, {
    shallow,
    locale,
    scroll
  });
}

const Link = /*#__PURE__*/_react.default.forwardRef((props, forwardedRef) => {
  const {
    legacyBehavior = Boolean(false) !== true
  } = props;

  if (false) {}

  let children;

  const {
    href: hrefProp,
    as: asProp,
    children: childrenProp,
    prefetch: prefetchProp,
    passHref,
    replace,
    shallow,
    scroll,
    locale,
    onClick,
    onMouseEnter
  } = props,
        restProps = _objectWithoutProperties(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter"]);

  children = childrenProp;

  if (legacyBehavior && typeof children === 'string') {
    children = /*#__PURE__*/_react.default.createElement("a", null, children);
  }

  const p = prefetchProp !== false;
  const router = (0, _router1).useRouter();

  const {
    href,
    as
  } = _react.default.useMemo(() => {
    const [resolvedHref, resolvedAs] = (0, _router).resolveHref(router, hrefProp, true);
    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]);

  const previousHref = _react.default.useRef(href);

  const previousAs = _react.default.useRef(as); // This will return the first child, if multiple are provided it will throw an error


  let child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react.default.Children.only(children);
    }
  }

  const childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;
  const [setIntersectionRef, isVisible, resetVisible] = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  });

  const setRef = _react.default.useCallback(el => {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react.default.useEffect(() => {
    const shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    const curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    const isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  const childProps = {
    ref: setRef,
    onClick: e => {
      if (false) {}

      if (!legacyBehavior && typeof onClick === 'function') {
        onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale);
      }
    },
    onMouseEnter: e => {
      if (!legacyBehavior && typeof onMouseEnter === 'function') {
        onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      }

      if ((0, _router).isLocalURL(href)) {
        prefetch(router, href, as, {
          priority: true
        });
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    const curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    const localeDomain = router && router.isLocaleDomain && (0, _router).getDomainLocale(as, curLocale, router && router.locales, router && router.domainLocales);
    childProps.href = localeDomain || (0, _router).addBasePath((0, _router).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react.default.cloneElement(child, childProps) : /*#__PURE__*/_react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if (typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) {
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 50046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Services; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/components/index.tsx + 10 modules
var components = __webpack_require__(75713);
// EXTERNAL MODULE: ./src/icons/index.tsx + 28 modules
var icons = __webpack_require__(27120);
// EXTERNAL MODULE: ./src/components/common/Carousel.tsx
var Carousel = __webpack_require__(10700);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Services/Service.tsx






const Service = ({
  name,
  description,
  icon
}) => /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
  w: "full",
  bg: "baseNeutral.700",
  rounded: "md",
  p: 6,
  borderRadius: 10,
  overflow: "hidden",
  h: "27rem",
  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
    h: {
      base: '10rem',
      md: '11rem'
    },
    pt: {
      base: '4',
      md: '1.5rem'
    },
    mt: -6,
    mx: -6,
    pos: "relative",
    bgColor: "white",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: icon,
      alt: name,
      layout: "fixed",
      width: "125%",
      height: "125%",
      loading: "lazy",
      objectFit: "contain"
    })
  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
    textAlign: "left",
    mt: "m",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
      as: "h5",
      color: "baseWhite",
      fontFamily: "Montserrat-SemiBold",
      fontSize: "0.875rem",
      letterSpacing: "0.4px",
      textTransform: "uppercase",
      children: name
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
      color: "baseWhite",
      fontFamily: "Montserrat-Regular",
      fontSize: "0.75rem",
      lineHeight: "18pxpx",
      letterSpacing: "0.2px",
      dangerouslySetInnerHTML: {
        __html: description
      } // dangerouslySetInnerHTML={{ __html: `Per essere sempre in regola e guidare in piena sicurezza<ul><li>Tutti gli interventi di controllo, riparazione e sostituzione degli pneumatici</li><li>Servizio di convergenza, equilibratura e controllo usura del battistrada</li><li>Su richiesta, sostituzione pneumatici invernali e/o estivo con supplemento di costo</li></ul>` }}

    })]
  })]
});

/* harmony default export */ var Services_Service = (Service);
;// CONCATENATED MODULE: ./src/components/Services/index.tsx









const Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Services__Title",
  componentId: "sc-8oaa3e-0"
})(["text-align:center;margin-top:2.5rem;margin-bottom:3rem;& svg{margin:auto;}"]);
const ServiceItemContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Services__ServiceItemContainer",
  componentId: "sc-8oaa3e-1"
})(["ul{margin-left:18px;margin-top:8px;}"]);

const ServicesList = ({
  title,
  services
}) => {
  const isMobile = (0,index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
    bg: "baseNeutral.800",
    pb: "1.375rem",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* Container */.W2, {
      paddingY: "0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* ArrowDownIcon */.ve, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          as: "h2",
          mx: "2",
          marginTop: "m",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "1.5rem",
          lineHeight: "31px",
          letterSpacing: ".68px",
          textAlign: "center",
          color: "baseWhite",
          children: title
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel/* default */.Z, {
        withCustomNavigation: !isMobile,
        breakpoints: {
          320: {
            slidesPerView: 1.3,
            spaceBetween: 18,
            centeredSlides: true
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 30
          }
        },
        withScrollbar: true,
        className: "offer-service-carousel",
        children: services.map(service => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel/* default.Item */.Z.Item, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceItemContainer, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Services_Service, {
                name: service.name,
                slug: service.slug,
                description: service.description,
                icon: service.icon
              })
            })
          }, service.slug);
        })
      })]
    })
  });
};

/* harmony default export */ var Services = (ServicesList);

/***/ }),

/***/ 10700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CarouselItem */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39091);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86173);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53918);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91712);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21669);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36797);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11972);
/* harmony import */ var swiper_css_grid__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_grid__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);












swiper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].use */ .ZP.use([swiper__WEBPACK_IMPORTED_MODULE_1__/* .Scrollbar */ .LW, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Navigation */ .W_, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Grid */ .rj]);
const Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].span.withConfig({
  displayName: "Carousel__Wrapper",
  componentId: "sc-1vzw1za-0"
})(["position:relative;display:", ";.swiper-grid-column{height:100%;}"], props => props.withCustomNavigation ? 'block' : 'inline');
/*
  workaround
  @see https://github.com/nolimits4web/swiper/issues/4413
  @see https://github.com/nolimits4web/swiper/issues/4084
*/

const Item = ({
  children
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: children
  });
};

const CarouselItem = ({
  children
}) => /*#__PURE__*/_jsx(SwiperSlide, {
  children: children
});

const Carousel = ({
  children,
  withScrollbar,
  withNavigation,
  withCustomNavigation,
  withPagination,
  slidesPerView,
  spaceBetween,
  className,
  breakpoints,
  grid
}) => {
  const {
    0: uniqueId,
    1: setUniqueId
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setUniqueId(`${Math.random()}`.substring(2, 15));
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(Wrapper, {
    className: className || '',
    withCustomNavigation: withCustomNavigation,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
      navigation: withCustomNavigation ? {
        nextEl: `.carousel-custom-next--${uniqueId}`,
        prevEl: `.carousel-custom-prev--${uniqueId}`
      } : withNavigation || false,
      pagination: withPagination ? {
        clickable: true
      } : false,
      scrollbar: withScrollbar ? {
        draggable: true,
        hide: false
      } : false,
      slidesPerView: slidesPerView || 'auto',
      spaceBetween: spaceBetween || 1,
      breakpoints: breakpoints,
      grid: grid,
      loopFillGroupWithBlank: true,
      children: [withCustomNavigation && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          className: `carousel-custom-next carousel-custom-next--${uniqueId}`
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          className: `carousel-custom-prev carousel-custom-prev--${uniqueId}`
        })]
      }), react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, child => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
        children: child
      }))]
    })
  });
};

Carousel.Item = Item;
/* harmony default export */ __webpack_exports__["Z"] = (Carousel);

/***/ }),

/***/ 85240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jj": function() { return /* binding */ getWindow; },
/* harmony export */   "Me": function() { return /* binding */ getDocument; }
/* harmony export */ });
/* unused harmony exports extend, ssrDocument, ssrWindow */
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */

/* eslint-disable no-param-reassign */
function isObject(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}

function extend(target = {}, src = {}) {
  Object.keys(src).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}

const ssrDocument = {
  body: {},

  addEventListener() {},

  removeEventListener() {},

  activeElement: {
    blur() {},

    nodeName: ''
  },

  querySelector() {
    return null;
  },

  querySelectorAll() {
    return [];
  },

  getElementById() {
    return null;
  },

  createEvent() {
    return {
      initEvent() {}

    };
  },

  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},

      setAttribute() {},

      getElementsByTagName() {
        return [];
      }

    };
  },

  createElementNS() {
    return {};
  },

  importNode() {
    return null;
  },

  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};

function getDocument() {
  const doc = typeof document !== 'undefined' ? document : {};
  extend(doc, ssrDocument);
  return doc;
}

const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState() {},

    pushState() {},

    go() {},

    back() {}

  },
  CustomEvent: function CustomEvent() {
    return this;
  },

  addEventListener() {},

  removeEventListener() {},

  getComputedStyle() {
    return {
      getPropertyValue() {
        return '';
      }

    };
  },

  Image() {},

  Date() {},

  screen: {},

  setTimeout() {},

  clearTimeout() {},

  matchMedia() {
    return {};
  },

  requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }

    return setTimeout(callback, 0);
  },

  cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }

    clearTimeout(id);
  }

};

function getWindow() {
  const win =  true ? window : 0;
  extend(win, ssrWindow);
  return win;
}



/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(77913)


/***/ })

}]);